import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule }
  from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/auth/authentication-service/authentication.service';

@Component({
  selector: 'app-login',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
  imports: [ReactiveFormsModule]
})
export class LoginPageComponent {

  public form = new FormGroup({
    "username": new FormControl("", Validators.required),
    "password": new FormControl("", Validators.required),
  });


  constructor(private loginSrvc: AuthenticationService, private router: Router) { }

  login() {
    const email = this.form.controls['username'].value ?? "";
    const password = this.form.controls['password'].value ?? "";
    this.loginSrvc.login(email, password);
  }
}
